<template>
  <div class="content background-set">

    <!--医生照片-->
    <div>
      <div align="center" class="div-img2">
        <img class="img-nature" :src="docInfo.headPortrait">
      </div>
    </div>

    <!--信息-->
    <div align="center" class="div-docInfo">
      <div class="doc-name">{{docInfo.realname}}</div>
      <p class="p-docInfo">{{docInfo.hospitalName}}&nbsp;&nbsp;&nbsp;{{docInfo.jobtitle}}</p>
      <p class="p-docInfo">{{docInfo.departChild}}</p>
    </div>

    <!--导航栏-->
    <cube-tab-bar v-model="selectedLabel" show-slider>
      <cube-tab class="cube-tab-bar" v-for="(item, index) in tabs" :label="item.label" :key="item.label">
      </cube-tab>
    </cube-tab-bar>
    <cube-tab-panels class = "background-set" v-model="selectedLabel">
      <cube-tab-panel v-for="(item, index) in tabs" :label="item.label" :key="index">
        <div   v-if="index===0" class="video-content">
          <div class="vedioText" v-if="item.info.length === 0 ">
            <span>{{vedioText}}</span>
          </div>
          <div v-for="(url,index) in item.info" :key="url.id || index" class="video-wrapper">
            <!--<div v-if="index===0" class="div-vedio">
              <img class="video-wrapper" :src="url.diyizhenUrl">
              <div class="iconfont icon-play play-button" v-on:click="playVedio(url.pathUrl)"></div>
            </div>-->
              <div class="image">
                <img style="width: 100%; height: auto" :src="url.diyizhenUrl">
                <div class="iconfont icon-play play-button" v-on:click="playVedio(url.pathUrl)"></div>
              </div>
            <!--<div>
              <img class="video-wrapper" :src="url.diyizhenUrl">
              <div class="iconfont icon-play play-button" v-on:click="playVedio(url.pathUrl)"></div>
            </div>-->
            <!--<div class="iconfont icon-play play-button" v-on:click="playVedio(url.pathUrl)"></div>-->
          </div>
         <!-- <img class="video-wrapper" v-for="url in item.info" :src="url">-->
        </div>
        <div v-if="index===1">
          <!--<div v-for="content in item.info">{{content}}</div>-->
          <div v-for="(content,contentIndex) in item.info" :key="'content_' + contentIndex">
            <div v-if="contentIndex===0">
              <span class="span-title">微简历</span>
              <div class="div-text">{{content}}</div>
            </div>
          </div>
          <div v-for="(content,contentIndex) in item.info" :key="'specialty_' + contentIndex">
            <div v-if="contentIndex===1">
              <span class="span-title">擅长</span>
              <div class="div-text">{{content}}</div>
            </div>
          </div>
        </div>
        <div v-if="index===2">
          <div class="vedioText" v-if="item.info.length === 0 ">
            <span>{{picText}}</span>
          </div>
          <img class="div-img1" v-for="url in item.info" :key="url.id" :src="url.pathUrl">
        </div>
      </cube-tab-panel>
    </cube-tab-panels>

    <!--播放视频-->
    <div class="play-div" v-if="playUrl.length>0" @click="playUrl = ''">
      <video v-if="playUrl.length>0" class="play-video" controls preload="auto" autoplay="autoplay">
        <source :src="playUrl" type="video/mp4">
      </video>
    </div>

    <!--预约按钮-->
    <div class="meetingButton"  @click="toYuYue(docInfo.id)">
      <div>预约</div>
    </div>
  </div>
    
</template>

<script>
import { getDoctorInfo, getAttachmentByDocId } from '@/api/docApi'

export default {
  components: {},
  props: {},
  data () {
    return {
      picText: '',
      vedioText: '',
      playUrl: '',
      docInfo: {},
      docAttachment: [],
      selectedLabel: '微简历',
      tabs: [{
        label: '微视频',
        info: []
      }, {
        label: '微简历',
        info: []
      }, {
        label: '写真集',
        info: []
      }]
    }
  },
  watch: {},
  computed: {},
  methods: {

    toYuYue: function (docId) {
      // console.log(docId)
      this.$router.push({
        path: '/docYuyue',
        query: {
          docId: docId
        }
      })
    },

    playVedio: function (info) {
      this.playUrl = info
    },

    // 获取医生详情
    async getDoctorDetail (docId) {
      const params = {
        doctorId: docId
      }
      const res = await getDoctorInfo(params)
      this.docInfo = res.obj
      this.tabs[1].info = []
      this.tabs[1].info.push(this.docInfo.content)
      this.tabs[1].info.push(this.docInfo.specialty)

      return this.docInfo
    },

    // 获取医生附件信息
    async getAttachment (docId) {
      const params = {
        doctorId: docId
      }
      const docInfo = await getAttachmentByDocId(params)
      if (!docInfo.obj) {
        this.picText = '暂时没有照片'
        this.vedioText = '暂时没有视频'
      } else {
        this.docAttachment = docInfo.obj
        const docres = this.docAttachment
        this.tabs[2].info = []
        this.tabs[0].info = []
        for (let i = 0; i < docres.length; i++) {
          if (docres[i].type === 0) {
            // 写真
            const docPic = {}
            docPic.pathUrl = docres[i].pathUrl
            this.tabs[2].info.push(docPic)
            /* console.log(docres[i].pathUrl)
              this.tabs[2].info.push(docres[i].pathUrl) */
          }
          if (docres[i].type === 1) {
            const docVideo = {}
            docVideo.pathUrl = docres[i].pathUrl
            docVideo.diyizhenUrl = docres[i].diyizhenUrl
            this.tabs[0].info.push(docVideo)
            /* this.tabs[0].info.push(docres[i].diyizhenUrl)
              this.tabs[0].info.push(docres[i].pathUrl) */
          }
        }
      }

     
      return this.docAttachment
    }
  },
  created () {
    const docId = this.$route.query.docId
    this.getAttachment(docId)
    this.getDoctorDetail(docId)
  },
  mounted () {}
}
</script>
<style lang="stylus" scoped>

  .vedioText{
    margin-top: 20px;
    margin-left: 20px;
    color:lightgray
  }

  .image {
    width 100%
  }
  >>>.cube-tab-bar-slider{
    background-color: yellow;
  }

  .play-div{
    width: 100%;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 999;
    background-color: rgba(0,0,0,0.8);
  }

  .play-video{
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

  }

  .play-button{
    position absolute
    bottom: 155px;
    left: 45%;
  }

  .div-vedio{
    position :relative;
    background #151518;
  }

  .meetingButton{
    position: sticky  // 使用sticky替代fixed
    position: -webkit-sticky  // 兼容Webkit浏览器
    bottom: 15px
    left: 10%
    width: 80%
    height: 40px
    line-height: 40px
    font-size: 20px
    color: #151518
    background: #FFF229
    text-align: center
    border-radius: 40px
    z-index: 999
    box-sizing: border-box
    display: flex
    align-items: center
    justify-content: center
    -webkit-overflow-scrolling: touch
    pointer-events: auto
    margin: 0 auto
    margin-top: 10px  // 添加顶部边距
    margin-bottom: 15px  // 添加底部边距
  }

  .cube-tab-bar{
    font-size: 20px;
    color: lightgray;
    border-bottom : gray solid 0.5px;
  }

  .background-set{
    background #292b2d

  }

  .div-img-title{
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .div-img1{
      width: 32%;
      height: 100px;
      margin-top: 5px;
      margin-left: 1%;
    }

  .span-title{
    color: yellow;
    font-size: 20px;
    padding: 8px;
  }

  .div-text{
    width: 95%;
    height: 180px;
    overflow-x: hidden;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    font-size: 15px;
    padding: 10px;
    margin-top: 0px;
    line-height: 1.5;
    color:lightgray;
  }
  .video-content {
    overflow: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
  .video-wrapper {
    position relative
    width 100%;
    margin-top: 5px;
    margin-bottom: 5px;
  }

.wrapper .name{
    color red
}
  .content{
    position:fixed;
    top:0;
    right:0;
    bottom:5px;
    left:0;
    overflow:auto;
    -webkit-overflow-scrolling:touch
  }

  .div-img2{
    width :100%;
    position :absolute
    top :32px
  }

  .img-nature{
    width :80px;
    height :80px;
    border-radius: 8px;
  }

  .div-docInfo{
    margin-top :72px;
    width :100%;
    height :150px;
    background-color: rgb(45,45,47);
    border-bottom: gray solid 1px;
  }

  .doc-name{
    color: #FFFFFF;
    font-size: 12px;
    padding-top: 51px;
  }

  .p-docInfo{
    color: #FFFFFF;
    font-size: 12px;
    margin: 0px;
    margin-top: 10px
  }
</style>
